import React from 'react';
import { NavLink } from 'react-router-dom';

var bnr1 = require('./../../images/background/bg-6.png');

class Specialization3 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="section-head m-b50 text-white text-center">
                                <h3 className="m-t0">Przed podjeciem każdej inicjatywy niezbędna jest wiedza</h3>
                                <p>Realizacja projektu skateparku wymaga nie tylko wiedzy technicznej, ale także głębokiego zrozumienia potrzeb społeczności, której ma służyć. To doświadczenie nie jest czymś, czego można się nauczyć na uniwersytecie – kluczowe są tutaj konsultacje społeczne i bezpośredni kontakt z pasjonatami sportów ekstremalnych. Każdy z członków naszej ekipy to doświadczeni entuzjaści, którzy wiedzą, jak ważne jest, aby skatepark był bezpieczny, funkcjonalny i dostosowany do oczekiwań użytkowników. Dzięki temu nasze projekty zawsze odpowiadają na rzeczywiste potrzeby społeczności, a skateparki, które tworzymy, stają się ulubionymi miejscami spotkań i rozwoju lokalnych talentów. Wśród nas są też osoby z wykształceniem inżynieryjnym i architektonicznym, co dodatkowo wzbogaca naszą ofertę o specjalistyczną wiedzę techniczną.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/1.jpg')}  alt=""/>
                                        <div className="figcaption">
                                            <h4>Krok pierwszy</h4>
                                            <p>Zadzwoń do nas lub napisz email.</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/2.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>Krok drugi</h4>
                                            <p>Oparacujemy wstepna koncepcje i umawiamy spotkanie</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/3.jpg')} alt=""/>
                                        <div className="figcaption bg-dark">
                                            <h4>Krok trzeci</h4>
                                            <p>Prezentujemy koncepcję podaczas konsultacji społecznych.</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization3;